<template>
  <div>

    <section class="content">
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('collection-center-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Paytm Collection Report</h3>
          
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Name</th>
                <th class="hidden-xs">Email</th>
                <th class="hidden-xs">Mobile</th>
                <th>Amount</th>
                <th class="hidden-xs">Order Id</th>
                <th class="hidden-xs">Received By</th>
                <th>Date</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.name }}</td>
                <td class="hidden-xs">{{ row.email }}</td>
                <td class="hidden-xs">{{ row.mobile }}</td>
                <td>{{ row.amt }}</td>
                <td class="hidden-xs">{{ row.order_id }}</td>
                <td class="hidden-xs">{{ row.received_by.name }}</td>
                <td>{{ row.created_at }}</td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">
                  <div v-if="row.status === 1">
                    <span class="label label-success">Success</span>
                  </div>
                  <div v-if="row.status === 0">
                    <span class="label label-danger">Failed</span>
                  </div>
                  <div v-if="row.status === 2">
                    <span class="label label-warning">Processing</span>
                  </div>
                </td>
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('paytm-view-any')"
                      type="button"
                      @click="viewModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="canAccess('paytm-view-any')"
                      type="button"
                      @click="printPaytmView(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->

    </section>
        <!-- /.modal -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Group Details</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Branch Name</b>
                              <a
                                class="pull-right"
                                v-if="row.branch"
                                >{{ row.branch.name }}</a
                              >
                          </li>
                          <li class="list-group-item">
                            <b>Cust Name</b>
                            <a class="pull-right">{{ row.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Email</b>
                            <a class="pull-right">{{ row.email }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Mobile</b>
                            <a class="pull-right">{{ row.mobile }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Amount</b>
                            <a class="pull-right">{{ row.amt }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Received By</b>
                              <a
                                class="pull-right"
                                v-if="row.received_by"
                                >{{ row.received_by.name }}</a
                              >
                          </li>
                          <li class="list-group-item">
                            <b>Payment Mode</b>
                            <a class="pull-right">{{ row.mode }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Order ID</b>
                            <a class="pull-right">{{ row.order_id }}</a>
                          </li>
                          <li class="list-group-item" style="padding-bottom: 28px;">
                            <b>Transaction ID</b>
                            <a class="pull-right">{{ row.transaction_id }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Date</b>
                            <a class="pull-right">{{ row.created_at }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a>
                              <span v-if="row.status === 1" class="label label-success pull-right">Success</span>
                              <span v-if="row.status === 0" class="label label-danger pull-right">Failed</span>
                              <span v-if="row.status === 2" class="label label-warning pull-right">Processing</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <paytmreceiptview :row="seeRecord" :getCompanyRecord="getCompanyRecord"></paytmreceiptview>

  </div>
</template>

<script>
import paytmreceiptview from '../components/PaytmReceipt.vue'
export default {
  name: 'OnlinePaymentReport',
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      row: {},
      per_page: 10,
      table_search: '',
      paytmRecords: {},
      getCompanyRecord: {},
      seeRecord: {},
      editMode: false,
      branches: {},
      officers: {},
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    printPaytmView (row) {
      this.seeRecord = {}
      this.seeRecord = row
      $('#paytmreceiptview').modal({backdrop: 'static', keyboard: false})
    },
    viewModal (row) {
      this.editMode = false
      this.row = {}
      this.row = row
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'paytm'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('collectioncenter?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(
    //       function (error) {
    //         Toast.fire({ icon: 'error', title: 'Please Try Again' })
    //         this.form.errors.errors = error.response.data.error
    //       }.bind(this)
    //     )
    // },
    loadBranch () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  components: {
    paytmreceiptview
  },
  created () {
    // this.loadData()
    this.changeFilter()
    this.loadBranch()
    this.loadCompanyProfile()
    Fire.$on('AfterCreate', () => {
      // this.loadData()
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// OnlinePaymentReport.vue?16315656